import React from "react";
import Modal from "../common/Modal/Modal";
import AttachmentPreview from "../common/AttachmentPreview";
import { numberWithCommas } from "../common/Helpers";

// A look-before-you-send step (GitHub #640) shown between filling out the
// invoice form and actually submitting it -- catches a wrong recipient,
// amount, or attachment before the invoice goes out. Read-only: to fix
// something, the user closes this and edits the form, they can't edit here.
export default function InvoiceReviewModal({
    handleClose,
    onConfirm,
    isSubmitting,
    confirmLabel,
    invoiceDraft,
    recipientName,
    contractName,
    projectName,
    officialFiles,
    additionalFiles,
    onDownloadAttachment
}) {
    return (
        <Modal blurBack={true} hasCloseButton={true} handleClose={handleClose} className="extra-wide">
            <h2 className="title2 heavy gap-below-s">Review before sending</h2>
            <p className="content1 light-black multiline gap-below-m">
                Double check the recipient, amount, and attachments below -- this can't be undone once sent.
            </p>

            <div className="info-grid c-3 gap-below-m">
                <div className="item firstcol">
                    <h4 className="content2 heavy-grey">Recipient</h4>
                    <p className="content1 light-black">{recipientName || "Not selected"}</p>
                </div>
                <div className="item">
                    <h4 className="content2 heavy-grey">Contract</h4>
                    <p className="content1 light-black">{contractName || "Not selected"}</p>
                </div>
                <div className="item">
                    <h4 className="content2 heavy-grey">Project</h4>
                    <p className="content1 light-black">{projectName || "Not selected"}</p>
                </div>
                <div className="item firstcol">
                    <h4 className="content2 heavy-grey">Invoice #</h4>
                    <p className="content1 light-black">{invoiceDraft.invoice_number || "—"}</p>
                </div>
                <div className="item">
                    <h4 className="content2 heavy-grey">PO #</h4>
                    <p className="content1 light-black">{invoiceDraft.po || "—"}</p>
                </div>
                <div className="item">
                    <h4 className="content2 heavy-grey">Total</h4>
                    <p className="content1 heavy">{invoiceDraft.total_value ? `$ ${numberWithCommas(invoiceDraft.total_value)}` : "—"}</p>
                </div>
            </div>

            <h4 className="content2 heavy-grey gap-below-xs">Official Invoice</h4>
            {officialFiles.length > 0
                ? officialFiles.map((f, i) => (
                    <AttachmentPreview key={i} file={f.file} attachment={f.attachment} onDownload={onDownloadAttachment} />
                ))
                : <p className="content1 g7-text gap-below-m">No file attached</p>}

            <h4 className="content2 heavy-grey gap-below-xs gap-above-m">Supporting Documents</h4>
            {additionalFiles.length > 0
                ? additionalFiles.map((f, i) => (
                    <AttachmentPreview key={i} file={f.file} attachment={f.attachment} onDownload={onDownloadAttachment} />
                ))
                : <p className="content1 g7-text gap-below-m">None attached</p>}

            <div className="flex-row gap-above-m">
                <button
                    id="confirm_send_invoice"
                    className="iblock btn expand pri gap-right-xs"
                    disabled={isSubmitting}
                    onClick={onConfirm}
                >{isSubmitting ? "Sending..." : confirmLabel}</button>
                <button className="iblock btn expand sec" disabled={isSubmitting} onClick={handleClose}>Back to Edit</button>
            </div>
        </Modal>
    );
}
